import React, { useEffect, useState } from "react";
import styled from "styled-components";


const FilterToggleControl = ({ value = undefined, label = undefined, count = undefined, visibleCount = undefined, caveat, handleFilterChange, activeFiltersArray, filterType, description, isBoolean = false, theme = undefined }) => {
  function getTypeLabel(type) {
    switch (type) {
      case "human-rights":
        return "Human Rights & Labor";
      case "environmental":
        return "Fishing & Environmental";
      case "uyghur-labor":
        return "Uyghur Labor";
      case "north-korean-labor":
        return "North Korean Labor";
      case "other":
        return "General Inquiry";
      default:
        return "";
    }
  }
  const textLabel = label || getTypeLabel(value);
  const [checked, setChecked] = useState(true);
  

  useEffect(() => {
    if ( isBoolean ) {
      if ( activeFiltersArray === true ) {
        setChecked(true);
      }
      else {
        setChecked(false);
      }
    }
    else if ( activeFiltersArray?.includes(value) || ( activeFiltersArray?.at(0) === "any" && activeFiltersArray?.length === 1 ) ) {
      setChecked(true);
    }
    else {
      setChecked(false);
    }
  }, [activeFiltersArray]);
  
  return (
    <>
      {count < 1 ? (
        <></>
      ) : (
        <StyledFilterToggleControl className={`is-${theme || value}`}>
          <input hidden type="checkbox" name={`filter-${value}`} value={value} checked={checked} id={`filter-${value}`} onChange={(e) => handleFilterChange(e, filterType)} />
          <span className="checkbox"></span>
          <span className="label">{textLabel}</span>
          <span className={`count ${visibleCount !== count ? "is-filtered" : undefined}`}>
            {/*visibleCount !== undefined && (
              <>
                <span className="count--visible">{visibleCount}</span>
                <span className="count--spacer">of</span>
              </>
            )*/}
            <span className="count--total">{count}</span>
          </span>
          {description && (
            <div className="description">{description}</div>
          )}
        </StyledFilterToggleControl>
      )}
    </>
  );
};

export default FilterToggleControl;

const StyledFilterToggleControl = styled.label`
  position: relative;
  z-index: 1;
  font-size: 0.875em;
  padding: 0.25em 0.5em;
  border-radius: 0.375em;
  display: grid;
  grid-template: auto / 1.375em 1fr 2.25em;
  //grid-template: auto / 1.375em 1fr 6em;
  gap: 0.5em;
  align-items: center;
  font-weight: 500;
  line-height: 1.3;
  border: 1px solid transparent;

  .can-hover &:hover,
  &::after {
    border-color: currentColor;
  }
  .checkbox {
    position: relative;
    display: block;
    border-color: currentColor;
    border: 2px solid;
    width: 0.9375em;
    height: 0.9375em;
    border-radius: 50%;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit;
      border: 1.5px solid var(--color-black);
    }
  }
  input:checked + .checkbox {
    background-color: currentColor;
  }
  &.is-human-rights .checkbox {
    color: var(--color-hr);
  }
  &.is-environmental .checkbox {
    color: var(--color-env);
  }
  &.is-uyghur-labor .checkbox {
    color: var(--color-uyg);
  }
  &.is-north-korean-labor .checkbox {
    color: var(--color-nk);
  }
  .label {
    font-weight: 500;
    opacity: 0.7;
  }
  .count {
    font-weight: 700;
    text-align: right;
    display: block;
    opacity: 0.7;
    display: flex;
    justify-content: flex-end;
    gap: 0.375em;
    .count--visible,
    .count--spacer {
      opacity: 0;
    }
    .count--spacer {
      font-weight: 500;
    }
    &.is-filtered {
      .count--visible {
        opacity: 1;
      }
      .count--spacer,
      .count--total {
        //opacity: 0.6;
      }
    }
  }
  .description {
    grid-column: 2 / span 3;
    font-size: 0.815em;
    font-weight: 400;
    opacity: 0.7;
    line-height: 1.3;
    margin-top: -0.25em;
  }
  input:checked ~ .label,
  input:checked ~ .count {
    opacity: 1;
  }
`;